let quanityIndexSelected = null;
let currencySelectedKey = null;
let currencySelectedLabel = null;

jQuery(document).ready(function ($) {
	let quantitySelector = $(".quantity-currency-selector select.quantity-range");
	let currencySelector = $(".quantity-currency-selector select.currencies");

    quantitySelector.each(function(index, element) {
        if ($(element).is(':visible')) {
            quanityIndexSelected = parseInt($(element).val());

            $(element).on('change', function() {
                quanityIndexSelected = parseInt($(this).val());

                updatePrice();
            });
        }
    });

    currencySelector.each(function(index, element) {
        if ($(element).is(':visible')) {
            currencySelectedKey = $(element).val();
            currencySelectedLabel = $('option:selected', $(element)).text();

            $(element).on('change', function() {
                currencySelectedKey = $(this).val();
                currencySelectedLabel = $('option:selected', $(this)).text();

                updatePrice();
            });
        }
    });

});

function updatePrice() {
    const quantityRangePrices = jQuery('.quantity-range-price');

	quantityRangePrices.each(function (index, element) {
		let prices = jQuery(element).data(currencySelectedKey);

		if (prices) {
			let price = prices[quanityIndexSelected];

			jQuery(element).text(price + " " + currencySelectedLabel);
		}
	});
}